import React from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import styles from './CollectionModal.scss';

const ConfirmationModal = (props) => {
  const {
    showModal,
    toggleModal,
    onConfirm
  } = props;

  return (
    <Modal
      zIndex="7000"
      isOpen={showModal}
      toggle={toggleModal}
      centered
      className={styles.addcreateModalContainer}
    >
      <ModalHeader
        toggle={toggleModal}
        tag="div"
        className={styles.modalHeader + ' ' +styles.noBorder}
        close={
          <div className={'my-auto ' + styles.closeButton}>
            <button className="close" onClick={toggleModal} aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        }
      >
        <span className={styles.modalTitle}>Do you want to remove this collection?</span>
      </ModalHeader>
      <ModalBody className={styles.modalBody}>
        <div className="d-flex m-3" id="body">
          When you remove this collection, the properties will still be saved in all properties.
        </div>
      </ModalBody>
      <ModalFooter className={styles.noBorder}>
        <div className={'d-flex w-100 pt-3 pb-3 justify-content-center align-items-center'}>
          <div className={'pl-4 pr-4 w-auto mr-2 ' + styles.cancelButton} onClick={toggleModal}>
            Cancel
          </div>
          <button className={'odinButton pl-4 pr-4 w-auto'} onClick={onConfirm}>
            Remove
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );

};

export default ConfirmationModal;